  // document.addEventListener('DOMContentLoaded', function () {
  //   const select = document.getElementById('collection_search_select_country_network');
  //   const rows = document.querySelectorAll('#network_row');
  //   console.log(select,"select",rows)
  //   select.addEventListener('change', function () {
  //     const selected = this.value;

  //     rows.forEach(row => {
  //       const countryName = row.getAttribute('data-country-name');
  //       console.log(countryName,selected ,'dfdfdf');
  //       if (!selected || countryName === selected) {
  //         row.style.display = 'flex';
  //       } else {
  //         row.style.display = 'none';
  //       }
  //     });
  //   });
  // });




  document.addEventListener('DOMContentLoaded', function () {
    const select = document.getElementById('collection_search_select_country_network');
    const rows = document.querySelectorAll('#network_row');
    const networkBox = document.querySelector('.network_box');
    if(select){
    select.addEventListener('change', function () {
      const selected = this.value;

      // Reset all rows
      rows.forEach(row => {
        row.classList.remove('active_row');
        const countryName = row.getAttribute('data-country-name');

        if (!selected || countryName === selected) {
          row.style.display = 'flex';
          if (countryName === selected) {
            row.classList.add('active_row');
          }
        } else {
          row.style.display = 'none';
        }
      });

      // Add or remove active_dropdown from the network box
      if (selected) {
        networkBox.classList.add('active_dropdown');
      } else {
        networkBox.classList.remove('active_dropdown');
      }
    });
    }
  });

